module.exports = __webpack_public_path__ + "static/laweta-daf-47f7e380653fff657d43223760e923de.webp";